import apiClient, { appendQueryParams } from "./client";

export type Session = {
  _id: string;
  title: string;
  isActive?: boolean;
  status?: string;
};

export type System = {
  _id: string;
  name: string;
};

export type ClassItem = {
  _id: string;
  name: string;
  registrationType: "interview+test" | "interview";
  system: string;
};

// Public, unauthenticated lookup endpoints. Mirror the shape returned by
// the existing authenticated endpoints (mpa-admin/src/service/...) so the
// admin and the parent-facing form can stay in sync.
//
// `branch` scopes both to this form's campus — without it, sessions/systems
// from every campus come back mixed together with no way to tell them apart
// (sessions are per-campus documents; several share the same title, e.g.
// "Aug 2026-2027").
export const getAllSessions = async (branch?: string): Promise<Session[]> => {
  const res = await apiClient({
    url: appendQueryParams("/public/sessions", { branch }),
    method: "GET",
  });
  const raw = res.data?.data ?? res.data ?? [];
  return Array.isArray(raw) ? raw : [];
};

export const getAllSystems = async (branch?: string): Promise<System[]> => {
  const res = await apiClient({
    url: appendQueryParams("/public/systems", { branch }),
    method: "GET",
  });
  return res.data?.data ?? res.data ?? [];
};

export const getClassesBySystem = async (
  system: string
): Promise<ClassItem[]> => {
  const res = await apiClient({
    url: appendQueryParams("/public/classes", { system, limit: 100 }),
    method: "GET",
  });
  const raw = res.data?.classes ?? res.data?.data ?? res.data ?? [];
  return Array.isArray(raw) ? raw : [];
};
